import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './QToaastContent.scss';
export const QToastContent = (props) => {
    const renderIcon = () => {
        if (!props.iconKey)
            return;
        const Icon = ICONS[props.iconKey];
        return _jsx(Icon.component, {});
    };
    return _jsxs("div", { className: _className('q-toast', props.toastType), children: [renderIcon(), _jsx("span", { className: 'toast-text', children: props.content })] });
};
//# sourceMappingURL=QToastContent.js.map